import { ObjectPreview } from './ObjectPreview';

export default ObjectPreview;
